import React from 'react'
import {Consumer} from '../../context'
import Spinner from '../layout/Spinner'
import New from '../news/New'

class News extends React.Component{
    render(){
        return(
            <React.Fragment>
            <Consumer>
                    {value=> {
                        const {articles, heading} = value
                        if (articles === undefined || articles.length === 0){
                            return <Spinner/>
                        } else {
                            return (
                                <React.Fragment>
                                    <h5 className="text-center mb-4">{heading}</h5>
                                        <div className ="row">
                                                {articles.map((item , id)=> <New key={id} result={item} aid={id} />)}     
                                            </div>                         
                               </React.Fragment>
                            )
                        }
                    }}

            </Consumer>
            </React.Fragment>
        )
    }
}


export default News